import { useMutation } from "@tanstack/react-query";
import { z } from "zod/v4";

import data from "../../assets/mocks/market-cars.json";

import { api } from "@/lib/api-client";
import { AxiosMock } from "@/utils/mock";

import type { MutationConfig } from "@/lib/react-query";
import type { PaginatedList } from "@/types/entity";
import type { MarketCar } from "@/types/market";

if (import.meta.env.MODE === "test") {
  // // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  mock.onPost(/\/carburate\/market\/cars\/search\//).reply(200, data);
}

export const searchMarketCarsInputSchema = z.object({
  full_text: z.string().optional(),
  make: z.string().optional(),
  model: z.string().optional(),
  year: z.string().optional(),
});

export type SearchMarketCarsInput = z.infer<typeof searchMarketCarsInputSchema>;

export const searchMarketCars = ({
  data,
}: { data?: SearchMarketCarsInput; page?: number } = {}) => {
  return api.get(`/carburate/market/cars/search/?full_text=${data?.full_text}`) as Promise<
    PaginatedList<MarketCar>
  >;
};

type UseSearchMarketCarsOptions = {
  data?: SearchMarketCarsInput;
  mutationConfig?: MutationConfig<typeof searchMarketCars>;
  page?: number;
};

export const useSearchMarketCars = ({ mutationConfig }: UseSearchMarketCarsOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: searchMarketCars,
  });
};
